import { plainToClass } from "class-transformer";
import ApiService from "../Services/ApiService";
import { Route } from "../Objects/enums/RouteEnum";
import Teachr from "../Objects/models/Teachr";
import TeachrHours from "../Objects/models/TeachrHours";
import Client from "../Objects/models/Client";
import CustomToken from "../Objects/interfaces/CustomToken";
import { ENV_DECLARONS, getActiveBrand, isBrandActive } from "../config/environment.config";
import { DispatchClientParams } from "../config/CLIENT_TYPE_CONFIG";


export default abstract class TeachrRepository {

    public static getInfoBySiret(siret: string) {
        return ApiService.get(`/teachrs/v3/teachrs/sirene/${siret}`);
    } 
    public static  getAllClientsForTeachr = (data: DispatchClientParams) => {
        const params = new URLSearchParams();
        params.set(`archive`, String(data.archive))
        params.set(`page`, String(data.page))
        params.set(`var`, String(data.variable))
        params.set(`sort`, String(data.sort))
        params.set(`limit`, String(data.limit))
        params.set(`brand`, String(getActiveBrand()))
        if (data.validated !== undefined) params.set(`validated`, String(data.validated))
        if (data.search) params.set(`search`, String(data.search))
        if (data.onlyActive) params.set(`status`, String('APPAREILLAGE_VALIDE'))
        if (data.status) {
            if (Array.isArray(data.status)) {
                data.status.forEach(status => params.append(`status[]`, String(status)));
            } else {
                params.set(`status`, String(data.status));
            }
        }
        return ApiService.get(`${Route.TEACHR_V3_BASE}all_clients/${data.teachrId}?${params.toString()}`)
    }

    public static teachrsUpdateLevelAndProcuration({ teachrId, level, procuration }: { teachrId: number, level: string, procuration: string }) {
        const params = new URLSearchParams();
        params.set(`level`, String(level))
        params.set(`procuration`, String(procuration))
        return ApiService.put(`${Route.TEACHR_V3_BASE}level_and_procuration/${teachrId}?${params.toString()}`);
    }



    public static getTeachrToken(uid: string) {
        return ApiService.getSingleInstance<CustomToken>(
            `/teachrs/v2/teachrs/create_token/${uid}`,
            String
        );
    }
    public static getCurrentTeachr() {
        return ApiService.getSingleInstance<Teachr>(Route.TEACHR_BASE + Route.TEACHR_ME, Teachr)
    }
    public static getCurrentUser(uid: string) {
        return ApiService.get(`/find/user/${uid}${isBrandActive(ENV_DECLARONS) ? `?brand=${getActiveBrand()}` : ''}`)
    }

    /**
     * Fetch a Teachr stored into the API by his id, client side
     * @param id
     */
    public static fetchTeachrById(id: number) {
        return ApiService.getSingleInstance<Teachr>(
            Route.TEACHR_BASE + "/" + id,
            Teachr
        );
    }
    /**
     * Fetch a Teachr stored into the API by his id, client side
     * @param code
     */
    public static fetchTeachrByCode(code: string) {
        return ApiService.getSingleInstance<Teachr>(
            "/teachr/code/" + code,
            Teachr
        );
    }


    /**
     * Creates an instance of Teachr into the API.
     * @param teachr
     */
    public static createTeachr(teachr: Teachr) {
        return ApiService.postInstance<Teachr>(
            Route.TEACHR_BASE,
            Teachr,
            teachr
        );
    }
    public static getToken() {
        return ApiService.getValidJWTToken()
    }

    public static get_client_by_teacher_favorite(
        teachrId: number, page: number = 1, archive: number = 0, param?: string, variabl: number = 0, sort: number = 1, limit: number = 10
    ) {
        return ApiService.get(
            `/teachrs/clients/${teachrId}?page=${page}&archive=${archive}&param=${param}&var=${variabl}&sort=${sort}&limit=${limit}${isBrandActive(ENV_DECLARONS) ? `&brand=${getActiveBrand()}` : ''}`
        );
    }

    public static get_client_by_teacher_favorite_only_actif(teachrId: number, page: number = 1, param?: string, limit: number = 10) {
     
        return ApiService.get(`/teachrs/clients/${teachrId}?page=${page}&param=${param}&only_actif=1&limit=${limit}${isBrandActive(ENV_DECLARONS) ? `&brand=${getActiveBrand()}` : ''}`);
    }

    /**
     * Updates the instance of the Teachr passed as parameter.
     * @param teachr
     */
    public static updateTeachr(teachr: Teachr) {
        if (typeof teachr.profilePicture !== "string") {
            teachr.profilePicture = undefined;
        }
        if (typeof teachr.proofIsAE !== "string") {
            teachr.proofIsAE = undefined;
        }
        if(typeof teachr.proofIdentity !== "string") {
            teachr.proofIdentity = undefined;
        }
        if(typeof teachr.proofMandat !== "string") {
            teachr.proofMandat = undefined;
        }
        if(typeof teachr.proofIdentity2 !== "string") {
            teachr.proofIdentity2 = undefined;
        }
  
        if(typeof teachr.proofSignSap !== "string") {
            teachr.proofSignSap = undefined;
        }

        return ApiService.putInstance<Teachr>(
            Route.TEACHR_BASE + "/" + teachr.id,
            Teachr,
            teachr
        );
    }

    /**
     * Returns the number of hours and courses given by teachr
     * @param teachr
     */
    public static getTeachrHours(teachrId: number) {
        return ApiService.get(`/clients/v2/teachrs/${teachrId}/hours`)
            .then(body => plainToClass(TeachrHours, body));
        ;
    }

    // public static searchClient(teachr: number, term: any) {
    //     return ApiService.get(`/teachrs/${teachr}/search/${term}`);
    // }
    // /teachrs/{teachr}/favorite/{mail}/add/{phone}
    /**
     * Adds a favorite teachr by even teachr
     * @param client
     * @param teachr
     */
    public static addFavoriteTeachr(teachr: number, mail: string, phone: string) {
        return ApiService.postInstance(
            Route.TEACHR_BASE + "/" + teachr + "/favorite/" + mail + "/add/" + phone,
            Client,
            null
        );
    }


}
